import {Button, openDialog} from 'platform/components';
import {HStack, Text} from 'platform/foundation';

import {SecondaryRecordId} from '@dms/api/core';
import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {SendCustomerEmailForm} from '../../SendCustomerEmailForm/SendCustomerEmailForm';
import {SendCustomerSmsForm} from '../../SendCustomerSmsForm/SendCustomerSmsForm';

interface CommunicationThreadComposerProps {
  customerId: string;
  recordId: string;
  resourceId: EntityResourceIds;
  secondaryRecordIds?: SecondaryRecordId[];
  defaultEmailAddress?: string | Nullish;
  defaultPhoneNumber?: string | Nullish;
}

export function CommunicationThreadComposer(props: CommunicationThreadComposerProps) {
  const handleNewEmail = () =>
    openDialog(
      <SendCustomerEmailForm
        customerId={props.customerId}
        recordId={props.recordId}
        resourceId={props.resourceId}
        secondaryRecordIds={props.secondaryRecordIds}
        defaultValues={{customerEmailAddress: props.defaultEmailAddress}}
      />,
      {withAdditionalFooter: true, size: 'large', title: i18n.t('general.actions.sendEmail')}
    );

  const handleNewSms = () =>
    openDialog(
      <SendCustomerSmsForm
        customerId={props.customerId}
        recordId={props.recordId}
        resourceId={props.resourceId}
        secondaryRecordIds={props.secondaryRecordIds}
        defaultPhoneNumber={props.defaultPhoneNumber}
      />,
      {scrollBehavior: 'outside', size: 'large', title: i18n.t('general.labels.smsMessage')}
    );

  return (
    <HStack height="100%" align="center" spacing={2}>
      <Text size="small" color="tertiary">
        {i18n.t('general.labels.newMessage')}
      </Text>
      <Button
        variant="outlined"
        size="small"
        leftIcon="communication/email"
        title={i18n.t('general.labels.email')}
        onClick={handleNewEmail}
      />
      <Button
        variant="outlined"
        size="small"
        leftIcon="communication/textsms"
        title={i18n.t('general.labels.sms')}
        onClick={handleNewSms}
      />
    </HStack>
  );
}
